const CancelIcon = () => {
  return (
    <span className="px-2 py-1 text-xs
    text-gray-600 dark:text-gray-300
    border border-transparent
    hover:border-gray-300 dark:hover:border-gray-600
    hover:bg-gray-100 dark:hover:bg-gray-800
    rounded-md transition-all duration-200 cursor-pointer">
      Cancel
    </span>
  );
};

export default CancelIcon;
